import axiosInstance from "../axiosInstance";

export const getDashboardSummary = async (params = {}) =>
  (await axiosInstance.get("dashboard/summary/", { params })).data;

export const getBranches = async () =>
  (await axiosInstance.get("branches/")).data;

export const getInternalBranding = async () =>
  (await axiosInstance.get("internal/branding/")).data;
